import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'
import RedirectWidget from 'organization/Event/WidgetConfig/RedirectWidget'
import ButtonWidget from 'organization/Event/WidgetConfig/ButtonWidget'
import CalendarWidget from 'organization/Event/WidgetConfig/CalendarWidget'
import {
  ButtonTemplate,
  CalendarTemplate,
  Widget,
  RedirectTemplate,
} from 'Event/Widget/template'

export default function WidgetsList(props: {
  widget: Widget | null
  updateWidget: (updatedFields: Partial<Widget>) => void
}) {
  const {widget, updateWidget} = props

  if (!widget) {
    return <Skeleton height={300} />
  }

  const updateRedirect = (updatedFields: Partial<RedirectTemplate>) => {
    updateWidget({
      template: {
        ...widget.template,
        redirect: {
          ...widget.template.redirect,
          ...updatedFields,
        },
      },
    })
  }

  const updateButton = (updatedFields: Partial<ButtonTemplate>) => {
    updateWidget({
      template: {
        ...widget.template,
        button: {
          ...widget.template.button,
          ...updatedFields,
        },
      },
    })
  }

  const updateCalendar = (updatedFields: Partial<CalendarTemplate>) => {
    updateWidget({
      template: {
        ...widget.template,
        calendar: {
          ...widget.template.calendar,
          ...updatedFields,
        },
      },
    })
  }

  return (
    <div>
      <RedirectWidget
        redirect={widget.template.redirect}
        onChange={updateRedirect}
        widget={widget}
      />
      <ButtonWidget
        button={widget.template.button}
        onChange={updateButton}
        widget={widget}
      />
      <CalendarWidget
        calendar={widget.template.calendar}
        onChange={updateCalendar}
        widget={widget}
      />
    </div>
  )
}
